import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _createSuper from '@babel/runtime/helpers/esm/createSuper';
import { Component } from 'react';
import PlayerButton from '../PlayerButton/PlayerButton.js';
import ConditionalVisible from '../ConditionalVisible/ConditionalVisible.js';
import './MenuButton.scss';
import { jsxs, jsx } from 'react/jsx-runtime';
import '../PlayerButton/PlayerButton.scss';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@dtvgo/classnames';
import '../ConditionalVisible/ConditionalVisible.scss';

var MenuButton = /*#__PURE__*/function (_Component) {
  _inherits(MenuButton, _Component);
  var _super = _createSuper(MenuButton);
  function MenuButton(props) {
    var _this;
    _classCallCheck(this, MenuButton);
    _this = _super.call(this, props);
    _this.state = {
      isMenuOpen: false
    };
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_assertThisInitialized(_this));
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  /**
   * @method handleMouseEnter
   * @description Method that show the menu content.
   */
  _createClass(MenuButton, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState({
        isMenuOpen: true
      });
    }

    /**
     * @method handleMouseLeave
     * @description Method that hide the menu content.
     */
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      if (this.wasOpenedWithClick) return;
      this.setState({
        isMenuOpen: false
      });
    }

    /**
     * @method handleClick
     * @description Method that handle toggle the menu content.
     */
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var _this$props = this.props,
        onClick = _this$props.onClick,
        showOnClick = _this$props.showOnClick;
      onClick(event);
      if (showOnClick) {
        this.setState(function (state) {
          return {
            isMenuOpen: !state.isMenuOpen
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        children = _this$props2.children,
        tooltip = _this$props2.tooltip,
        buttonContent = _this$props2.buttonContent,
        showOnClick = _this$props2.showOnClick;
      var isMenuOpen = this.state.isMenuOpen;
      return /*#__PURE__*/jsxs(PlayerButton, {
        className: "dtv-common-c-menu-button ".concat(className),
        tooltip: tooltip,
        onClick: this.handleClick,
        onMouseEnter: showOnClick ? undefined : this.handleMouseEnter,
        onMouseLeave: showOnClick ? undefined : this.handleMouseLeave,
        children: [buttonContent, /*#__PURE__*/jsx(ConditionalVisible, {
          className: "dtv-common-c-menu-button__menu",
          transitionSeconds: 0.5,
          visible: isMenuOpen,
          children: children
        })]
      });
    }
  }]);
  return MenuButton;
}(Component);
MenuButton.defaultProps = {
  children: [],
  buttonContent: [],
  className: '',
  tooltip: '',
  showOnClick: true,
  onClick: function onClick() {}
};

export { MenuButton as default };
//# sourceMappingURL=MenuButton.js.map
